import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43076dc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popUp" }
const _hoisted_2 = { class: "wrapper-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "wrapper-title" }, " You have some unsaved files. Upload them to drive? ", -1))
const _hoisted_4 = { class: "wrapper-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
      class: "wrapper"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("a", {
          class: "btn btn-upload",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('on-accept')))
        }, " Yes ")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: "javascript:void(0);",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"])),
          class: "btn btn-cancel"
        }, " No ")
      ])
    ])
  ]))
}